import { generatePath } from 'react-router'
import clientEnv from '../../../utils/global/clientEnv'
import { NavSupportedEnvironment } from '../../../exports/routing'
import { type PartnerContextValue } from '../../../utils/contexts/partner/PartnerContext'

// When the current env doesn't match an entry's declared `environment` (e.g.
// prod → dev-only Fulfillment Testing), produce a full external URL pointing
// at the entry's target env. Returns undefined for same-env entries so the
// caller falls back to in-app navigation.
export const getHrefOverride = (
  route: string,
  environment: string,
  partnerContext: PartnerContextValue,
  routesByName: { [key: string]: string },
  retailerId: string | null | undefined
) => {
  let hrefOverride: string | undefined
  if (
    environment &&
    environment !== clientEnv.PUBLIC_CLIENT_ENVIRONMENT &&
    (clientEnv.PUBLIC_CLIENT_ENVIRONMENT === NavSupportedEnvironment.Production ||
      clientEnv.PUBLIC_CLIENT_ENVIRONMENT === NavSupportedEnvironment.Dev)
  ) {
    const pathPattern = routesByName[route]
    const pathParams: Record<string, string> = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      // @ts-expect-error TS2322 — strictNullChecks. TODO: fix strict null check
      partner_id: partnerContext?.partnerId,
    }

    if (pathPattern?.match(/:warehouse_id(?:\/|$|\?)/)) {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      pathParams.warehouse_id = retailerId ?? '0'
    }
    if (environment === NavSupportedEnvironment.Production) {
      hrefOverride = `${clientEnv.PUBLIC_CLIENT_PRODUCTION_URL}${generatePath(
        pathPattern,
        pathParams
      )}`
    } else if (environment === NavSupportedEnvironment.Dev) {
      hrefOverride = `${clientEnv.PUBLIC_CLIENT_RPP_DEV_URL}${generatePath(pathPattern, pathParams)}`
    }
  }

  return hrefOverride
}
